if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Estamos buscando tu paquete...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Buscando…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "ES"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat zamiast "no encontrado"
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Demasiados intentos
            </div>

            <div class="ee-error-message">
                Has realizado demasiadas búsquedas seguidas.
                Espera un minuto e inténtalo de nuevo.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                El pedido ha sido cancelado
            </div>

            <div class="ee-error-message">
                Este pedido ha sido cancelado y no será procesado.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Estamos preparando tu pedido
                </div>

<div class="ee-info-message">


 <br>

    Tu pedido ha sido recibido y se está procesando.

    <br><br>

    Todavía no se ha asignado un número de seguimiento.
    Una vez que se envíe tu paquete, la información de seguimiento estará disponible en esta página y por correo electrónico.

    <br><br>

    Si tienes más preguntas sobre tu pedido, ponte en contacto con nuestro equipo de atención al cliente.

    <br>

                    <a href="https://euroelectronics.es/pages/contacto" class="ee-contact-link">
                        Contacto
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Pedido no encontrado
                </div>

                <div class="ee-error-message">
                    No hemos podido encontrar ningún pedido que coincida con el número de pedido y la dirección de correo electrónico proporcionados.

                    Comprueba que los datos se hayan introducido correctamente e inténtalo de nuevo.
                    <br><br>

                    Si necesitas ayuda, ponte en contacto con nuestro equipo de atención al cliente.
                    <br>

                    <a href="https://euroelectronics.es/pages/contacto" class="ee-contact-link">
                        Ir al formulario de contacto
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Paquete encontrado
                        </div>
<div class="ee-result-description">
                            A continuación encontrarás la información sobre tu paquete.
                          
                            Haz clic en el botón de abajo para ir directamente al seguimiento con el transportista.
                           
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Número de pedido
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Número de seguimiento
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Rastrear paquete
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Productos pedidos (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Ha ocurrido un error
                        </div>

                        <p>
                            No hemos podido conectar con el sistema de seguimiento.
                            Inténtalo de nuevo en unos instantes.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}